import { Component, Inject, OnInit } from '@angular/core';
import { CallService } from '../../../../../src/app/shared/services';
import moment from 'moment';
import { Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Constants } from '../../../../../src/app/shared/misc/constants';

interface Notification {
	id : string;
	title : string;
	excerpt : string;
	html : string;
	created_date : string;
	read_at : string | null;
	type : 'critical' | 'system' | 'info';
	expanded : boolean;
}

@Component({
	selector    : 'menu-header-notifications',
	templateUrl : './notifications.component.html',
	styleUrls   : ['./notifications.component.scss']
})
export class HeaderNotificationsComponent implements OnInit {
	private renderer : Renderer2;
	private htmlEl : HTMLElement;
	public notifications : Notification[] = [];
	public isOpen = false;
	public hasUnreadNotifications : boolean = false;
	public unreadCount : number = 0;

	constructor(private call : CallService,
	            rendererFactory : RendererFactory2,
	            @Inject(DOCUMENT) private doc : Document)
	{
		this.renderer = rendererFactory.createRenderer(null, null);
		this.htmlEl = this.doc.documentElement;
	}

	ngOnInit()
	{
		this.loadNotifications();
	}

	private loadNotifications() : void
	{
		this.call.make<Notification[]>('systemnews/getNews').subscribe(notifications => {
			this.notifications = notifications;

			this.notifications.forEach(n => n.expanded = false);

			this.updateUnreadStatus();

			if (this.notifications.length > 0 && !this.notifications[0].read_at) {
				this.open();
				this.notifications[0].expanded = true;
				this.markAsRead(this.notifications[0]);
			}
		});
	}

	private updateUnreadStatus() : void
	{
		const unreadNotifications = this.notifications.filter(n => !n.read_at);
		this.unreadCount = unreadNotifications.length;
		this.hasUnreadNotifications = this.unreadCount > 0;
	}

	public open() : void
	{
		this.isOpen = true;
		this.renderer.addClass(this.htmlEl, 'is-open');
	}

	public close() : void
	{
		this.isOpen = false;
		this.renderer.removeClass(this.htmlEl, 'is-open');
	}

	getIcon(type : string) : string
	{
		switch (type) {
			case Constants.SYSTEMNEWS_CRITICAL:
				return 'pi pi-exclamation-triangle';
			case Constants.SYSTEMNEWS_SYSTEM:
				return 'pi pi-info-circle';
			default:
				return 'pi pi-bell';
		}
	}

	public formatTimeAgo(timestamp : string) : string
	{
		return moment(timestamp).fromNow();
	}

	ngOnDestroy() : void
	{
		this.renderer.removeClass(this.htmlEl, 'is-open');
	}

	private markAsRead(notification : Notification) : void
	{
		this.call.make('systemnews/markArticlesAsRead', {article_ids : [notification.id]}).subscribe(() => {
			notification.read_at = new Date().toISOString();

			this.updateUnreadStatus();
		});
	}

	public markAllAsRead() : void
	{
		const unreadIds = this.notifications
		.filter(n => !n.read_at)
		.map(n => n.id);

		if (unreadIds.length === 0) return;

		this.call.make('systemnews/markArticlesAsRead', {article_ids : unreadIds}).subscribe(() => {
			this.notifications.forEach(n => {
				if (!n.read_at) {
					n.read_at = new Date().toISOString();
				}
			});

			this.updateUnreadStatus();
		});
	}

	openContent(notification : Notification)
	{
		if (!notification?.html) return;

		// Don't toggle if user is selecting text (trying to copy)
		const selection = window.getSelection();
		if (selection && selection.toString().length > 0) {
			return;
		}

		notification.expanded = !notification.expanded;

		if (notification.expanded && !notification.read_at) {
			this.markAsRead(notification);
		}
	}
}
